import { calcular_resultados_finais_por_aluno } from "./calcular-resultados-finais-por-aluno";
import { calcular_resultados_finais_por_turma } from "./calcular-resultados-finais-por-turma";

const calcular_resultados_finais = [
  ...calcular_resultados_finais_por_aluno,
  ...calcular_resultados_finais_por_turma,
];

export { calcular_resultados_finais };
